export default __webpack_public_path__ + "static/media/fasting_13_11@2x.efec24dd.jpg";